import { Component, ChangeDetectorRef } from '@angular/core'
import {
	IonicPage,
	NavController,
	NavParams,
	ActionSheetController,
	AlertController,
	ToastController
} from 'ionic-angular'

import { AddressType, Device, Condominium, Message, MessageReceiverType, UIStrings } from '../../models/models'

import { AddressProvider } from '../../providers/address/address'
import { AuthProvider } from '../../providers/auth/auth'
import { CondominiumProvider } from '../../providers/condominium/condominium'
import { DeviceProvider } from '../../providers/device/device'
import { HousingUnitProvider } from '../../providers/housing-unit/housing-unit'
import { MessageProvider } from '../../providers/message/message'

import { AddressCreatePage } from '../address-create/address-create'
import { CondominiumEditPage } from '../condominium-edit/condominium-edit'
import { HousingUnitCreatePage } from '../housing-unit-create/housing-unit-create'
import { UserAddPage } from '../user-add/user-add'
import { MessageCreatePage } from '../message-create/message-create'
import { HousingUnitIndexPage } from '../housing-unit-index/housing-unit-index'
import { Paginator } from '../../models/interfaces'
import { ControlPanelPage } from '../control-panel/control-panel'
@IonicPage()
@Component({
	selector: 'page-condominium-show',
	templateUrl: 'condominium-show.html',
})
export class CondominiumShowPage {
	public condominium: Condominium = null;
	public isLoading: boolean = true;
	/**
	Messaggi in caricamento
	*/
	private _isMessagesLoading: boolean = null;
	public get isMessagesLoading(): boolean {
		return this._isMessagesLoading
	};
	public set isMessagesLoading(value: boolean) {
		this._isMessagesLoading = value
		this.changeDetector.detectChanges()
	}

	/**
	Messaggi visualizzati espansi
	*/
	private _isMessagesExpanded: boolean = null;
	public get isMessagesExpanded(): boolean {
		return this._isMessagesExpanded
	};
	public set isMessagesExpanded(value: boolean) {
		this._isMessagesExpanded = value
		this.changeDetector.detectChanges()
	}
	isDevicessExpanded

	/**
	 Dispositivi espansi
	 */
	private _isDevicesExpanded: boolean = null;
	public get isDevicesExpanded(): boolean {
		return this._isDevicesExpanded
	};
	public set isDevicesExpanded(value: boolean) {
		this._isDevicesExpanded = value
		this.changeDetector.detectChanges()
	}

	public messagePaginator: Paginator<Message>
	/*
	isHousingUnitsLoading:boolean=true;
	isContactsLoading:boolean=true;
	*/

	constructor(
		public actionSheetCtrl: ActionSheetController,
		public alertCtrl: AlertController,
		public auth: AuthProvider,
		private changeDetector: ChangeDetectorRef,
		public housingUnits: HousingUnitProvider,
		public addresses: AddressProvider,
		public condominiums: CondominiumProvider,
		public devices: DeviceProvider,
		public messages: MessageProvider,
		public navCtrl: NavController,
		public navParams: NavParams,
		public toastCtrl: ToastController
	) {
		let self = this

		this.condominium = navParams.get('condominium')
		if(this.condominium.housing_units) {
			//ordina le unità immobiliari
			this.condominium.housing_units = HousingUnitProvider.sort(this.condominium.housing_units)
		}

		this.messagePaginator = {
			next(before: Message = null, pagesize: number = 10): Promise<Message[]> {
				console.debug('[CondominiumShowPage.messagePaginator.next()] Richiesto il caricamento di ulteriori ' + pagesize + ' messaggi dal/al condominio, a partire da:', before)

				return new Promise<Message[]>((resolve, reject) => {
					self.messages.indexAll(
						self.condominium.id,
						MessageReceiverType.CONDOMINIUM,
						['condominium', 'condominium.userRoles', 'device', 'device.condominium', 'housingUnit', 'sender', 'receiver'],
						pagesize,
						before
					).then(
						(messages: Message[]) => {
							console.log('Recuperati altri messaggi dal/al condominio: ', messages)

							resolve(messages)
							self.isMessagesLoading = false//Eventuale primo caricamento, sblocca le UI
						},
						(error) => {
							console.error("Errore recuperando i messaggi dal/al condominio:", error)
							reject(error)
						}
					)
				})
			}
		}
	}

	/*
	Aggiorna i dati del condominio prima di visualizzarlo
	*/
	ionViewWillEnter() {
		this.refresh()
	}

	public goToControlPanel() {
		this.navCtrl.setRoot(ControlPanelPage)
	}
	/*
	Rilettura del condominio
	*/
	private refresh() {
		let self = this

		this.isLoading = true
		this.condominiums.getById(this.condominium.id, [
			'address',
			'devices',
			'contacts',
			'users',
			'housingUnits',
			'housingUnits.userRoles',
			'userRoles'
		]).then(
			(condominium: Condominium) => {
				//ordina le unità immobiliari
				condominium.housing_units = HousingUnitProvider.sort(condominium.housing_units)

				for(let device of condominium.devices) {
					//mette il condominio ai dispositivi senza caricarlo
					device.condominium = condominium
					device.condominium_id = condominium.id
				}

				//evito di perdere i vecchi messaggi
				let prevMessages = self.condominium.messages
				self.condominium = condominium
				self.condominium.messages = prevMessages

				/*
				self.condominium.housing_units = self.condominium.housing_units.sort((hu1: HousingUnit, hu2: HousingUnit) => {
					let s1 = (hu1.stair + '-'
						+ hu1.floor + '-'
						+ hu1.internal + '-'
						+ hu1.label).toUpperCase();

					let s2 = (hu2.stair + '-'
						+ hu2.floor + '-'
						+ hu2.internal + '-'
						+ hu2.label).toUpperCase();

					if (s1 === s2) return 0;
					if (s1 > s2) return 1;
					return -1;
				});
				*/

				self.isLoading = false
				console.log('Condominio recuperato: ', self.condominium)
			},
			(error) => {
				self.isLoading = false
				console.error("Errore recuperando i dati del condominio:", error)
				let toast = self.toastCtrl.create({
					message: 'Errore recuperando i dati del condominio',
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				})
				toast.present()
			}
		)

		this.loadMoreMessages(null, true)
	}

	goToCondominiumEdit(condominium: Condominium) {
		this.navCtrl.push(CondominiumEditPage, { condominium: condominium })
	}

	goToContactCreate(condominium: Condominium) {
		this.navCtrl.push(AddressCreatePage, {
			condominium: condominium,
			/*
			ownerType: 'App\\Condominium',
			ownerId: condominium.id,
			*/

			title: 'Nuovo contatto per il condominio "' + this.condominium.name + '"',

			type: AddressType.CONTACT,
			isNameWritable: true,
			isTypeWritable: false,
			isPriorityWritable: false
		})
	}

	goToHousingUnitCreate() {
		this.navCtrl.push(HousingUnitCreatePage, { condominium: this.condominium })
	}

	public goToHousingUnitIndex(event = null) {
		if(event) {
			event.stopPropagation()
		}
		this.navCtrl.push(HousingUnitIndexPage, { condominium: this.condominium })
	}


	public goToMessageCreate() {
		this.navCtrl.push(MessageCreatePage, {
			condominium: this.condominium
		})
	}

	goToUserAdd(role: string) {
		let options = {}
		options['is_' + role] = true
		options['condominium'] = this.condominium

		this.navCtrl.push(UserAddPage, options)
	}

	public loadMoreMessages(
		infiniteScroll = null,
		reload = false,
		beforeMessage: Message = null
	) {
		let self = this
		this.isMessagesLoading = true

		if(typeof this.condominium.messages === 'undefined' || reload) {
			this.condominium.messages = []
		} else if(this.condominium.messages.length > 0) {
			beforeMessage = this.condominium.messages[this.condominium.messages.length - 1]
		}

		this.messages.indexIncoming(
			this.condominium.id, MessageReceiverType.CONDOMINIUM,
			['condominium', 'device', 'device.condominium', 'housingUnit', 'sender', 'receiver', 'receiver.userRoles', 'receiver.housingUnits', 'receiver.housingUnits.userRoles'],
			10,
			beforeMessage
		).then(
			(messages: Message[]) => {
				console.log('Messaggi del condominio recuperati: ', messages)
				for(let message of messages) {
					self.condominium.messages.push(message)
				}

				self.isMessagesLoading = false

				if(infiniteScroll) {
					infiniteScroll.complete()
				}
			},
			(error) => {
				self.isLoading = false
				console.error("Errore recuperando i messaggi del condominio:", error)
				let toast = self.toastCtrl.create({
					message: 'Errore recuperando i messaggi del condominio',
					position: 'middle',
					duration: 3000,
					cssClass: "danger"
				})
				toast.present()

				if(infiniteScroll) {
					infiniteScroll.complete()
				}
			}
		)
	}

	public showDeviceAdd(condominium) {
		let self = this
		let alert = this.alertCtrl.create({
			title: 'Associa dispositivo al condominio',
			subTitle: 'ATTENZIONE: Il dispositivo verrà disassociato da altri condomini',
			message: 'Inserisci il codice identificativo generato dal dispositivo che vuoi associare, il dispositivo deve essere già stato registrato sul server',
			inputs: [
				{
					name: 'identifier',
					placeholder: 'Codice identificativo',
					id: 'device-add-identifier'
				},
			],
			buttons: [
				{
					text: UIStrings.DIALOG_CANCEL,
					role: 'cancel'
				}, {
					text: 'Associa quello corrente',
					handler: data => {
						let input = document.getElementById('device-add-identifier');
						(<HTMLInputElement>input).value = DeviceProvider.identifier

						/*
						let event=new Event("onchange",{"bubbles":true, "cancelable":true,"composed":true});
						input.dispatchEvent(event);
						*/

						return false
					}
				}, {
					text: 'Registra',
					handler: data => {
						console.log('Richiesta registrazione dispositivo', data)
						/*
						Non legge da data perchè ionic non lo aggiorna con il nuovo valore se è stato impostato programmaticamente
						*/
						let identifier = (<HTMLInputElement>document.getElementById('device-add-identifier')).value
						console.log('Identifier da associare:', identifier)
						if(identifier) {
							self.devices.register(identifier, self.condominium.id).then((device: Device) => {
								self.refresh()
								if(device) {
									let toast = self.toastCtrl.create({
										message: 'Dispositivo associato al condominio',
										position: 'middle',
										duration: 3000,
										cssClass: "light"
									})
									toast.present()
								} else {
									let toast = self.toastCtrl.create({
										message: 'Codice errato o dispositivo non ancora registrato',
										position: 'middle',
										duration: 3000,
										cssClass: "danger"
									})
									toast.present()
								}
							}).catch((error: any) => {
								self.refresh()
								let toast = self.toastCtrl.create({
									message: 'Errore associando il dispositivo',
									position: 'middle',
									duration: 3000,
									cssClass: "danger"
								})
								toast.present()
							})
						} else {
							return false
						}
					}
				}
			]
		})
		alert.present()
	}

	public showHousingUnitsMenu(event) {
		let self = this
		event.stopPropagation()

		let buttons = []

		buttons.push({
			text: UIStrings.LISTS,
			icon: 'list',
			handler: () => {
				self.goToHousingUnitIndex()
			}
		})

		if(this.auth.canHousingUnitCreate(this.condominium)) {
			buttons.push({
				text: UIStrings.CREATE,
				icon: 'add',
				role: 'destructive',
				handler: () => {
					self.goToHousingUnitCreate()
				}
			})
		}

		buttons.push({
			text: UIStrings.MENU_CLOSE,
			role: 'cancel',
			icon: 'undo',
			handler: () => {}
		})

		let options = {
			title: 'Unità immobiliari del condominio "' + this.condominium.name + '"',
			subTitle: '',
			buttons: buttons
		}

		if(this.condominium.address) {
			options.subTitle += "\n " + this.condominium.address.formatted
		}

		let actionSheet = this.actionSheetCtrl.create(options)
		actionSheet.present()
	}

}



// WEBPACK FOOTER //
// ./src/pages/condominium-show/condominium-show.ts